export default {
    common:{
        dateFormat: "DD.MM.YYYY",
        currency:  "CHF {value}",
        choose:     "Scelga",
        next:       "Continua",
        previous:   "Indietro",
        bestChoice: "La scelta migliora",
        and:        "e",
        or:         "o",
        edit:       "Modifica",
        basket:     "Carrello",
        yourStudio: "Il tuo club",
        yourPlan:   "Il tuo abbonamento",
        yourAddition: "I tuoi extra",
        noAddition: "Continuare senza extra",
        opening: "Apertura {date}"
    },
    widget:{
        studio:{
            searchPlaceholder: "Cerca per codice postale o città",
            clubList: "Elenco dei club",
            mapView : "Vista mappa"
        },
        basket:{
            totalAmount: "Totale",
        },
        user:{
            genderFemale: "Donna",
            genderMale: "Uomo",
            genderDivers: "Altro",
            firstname: "Nome",
            lastname: "Cognome",
            email: "E-Mail",
            phone: "Numero di telefono",
            birthday: "Data di nascità",
        },
        address:{
            street: "Via",
            streetno: "Numero",
            zipcode: "Codice Postale",
            city: "Città",
            country: "Paese",
        },
        membership:{
            membership: "Abbonamento",
            startOfMembership: "Inizio del tuo abbonamento",
            trainingsStart: "Inizio dell´allenamento dal {date}",
            rightAway: "Subito",
        }
    },
footer:{
            backToHomepage: "Ritorna al sito web",
            imprint: "Impressum",
            dataProtection: "Protezione Dati",
            paymentOptions: "Opzioni di pagamento",
        },
    steps: {
        step1_1: "Scegli un club",
        step1_2: "Scegli l´abbonamento",
        step1_3: "Scegli gli extra",
        step1_4: "Riassunto",
        step2_1: "Dati personali",
        step2_2: "Indirizzo",
        step2_3: 'Pagamento',
        step2_4: "Check-Out",
    },
    pages:{
        selectClub:{
            headline: "Scegli il tuo club",
        },
        selectContract: {
            headline: "Scegli l´abbonamento",
            choosePlan: "Scegli il tuo abbonamento",
            chooseRuntime: "Scegli la durata dell'abbonamento",
            basisPlan: "La nostra offerta Core",
            premiumPlan: "La nostra offerta Premium",
            planPoints: [
                "Basefit.ch app incl. live info della quantita´ di visitatori nel club",
                "Live Group Fitness On-Demand",
                "Accesso a tutti i club",
                "Il tuo amico si allena gratuitamente nel weekend",
                "Nessun periodo di preavviso",
                "Metti in pausa il tuo abbonamento",
                "Quota di iscrizione",
                "Monatlich kündbar",
            ]
        },
        selectAddition:{
            headline: "Completa il tuo abbonamento",
            unselectAddition: "Continuare senza extra",
        },
        overview:{
            headline: "Il tuo riassunto",
            yourData: "I tuoi dati",
        },
        selectData:{
                dataProtection: "Protezione Dati",
                checkboxDataPolice: "Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam {DP_URL}.",
                checkboxNewsletter: "Si, vorrei ricevere informazioni promozionali e informazioni su altri prodotti da Basefit.ch e dai suoi partner.",
                footerActionText: "Si prega di compilare",
                yourData: "I tuoi dati",
            },
        selectAddress:{
                yourAddress: "Il tuo indirizzo",
                yourMembership: "Abbonamento",
                howDoYouKnow: "Come ci conosci?",
                footerName: "Ciao {fname}",
                footerActionText: "Per favore compilare qui il tuo indirizzo",
            },
            selectPayment:{
                yourPaymentOptions: "I tuoi metodi di pagamento",
                healthInsuranceRefund: "Rimborso dell'assicurazione sanitaria",
                checkboxHealthInsuranceRefund: "Si, desidero beneficiare del programma bonus swica - fino a un rimborso di CHF 527.25 – ed essere contattato. Acconsento al trasferimento dei miei dati a Swica. Ulteriori informazioni possono essere trovate {url}.",
                checkboxUrlText: "qui",
            },
        checkOut:{
            yourOverview: "Il tuo riassunto",
            yourData: "I tuoi dati",
            address: "Indirizzo",
            yourMembershipStart: "Inizio del tuo abbonamento",
            paymentInformation: "Informazioni sul pagamento",
            couponRedeem:  "Usare",
            coupon:    "Codice promozionale",
            couponAccept: "Il tuo codice promozionale {coupon} e´ stato accettato.",
            couponDecline: "Il tuo codice promozionale {coupon} non e´ stato accettato.",
            orderForFee: "Pagare",
            checkboxAGB: "Accetto {url_agb} e {url_dataprotection} di Basefit.ch.",
            checkboxURLAGB: "AGB",
        },
    },
};